import { motion } from "framer-motion";
import { TrendingUp, ArrowRight } from "lucide-react";
import { SEVERITY, agentMeta } from "@/sim/lib";
import { cn } from "@/lib/utils";

export function RemediationBacklog({ backlog = [] }) {
  if (!backlog.length) return null;
  return (
    <div data-testid="sim-backlog">
      <p className="sim-mono text-[11px] text-[#D4D4D8] uppercase tracking-wider mb-3">
        Prioritized UX Remediation Backlog · {backlog.length}
      </p>
      <div className="space-y-2.5">
        {backlog.map((o, i) => {
          const s = SEVERITY[o.severity] || SEVERITY.MEDIUM;
          const meta = agentMeta(o.agent_id);
          return (
            <motion.div
              key={i}
              data-testid={`sim-backlog-item-${i}`}
              initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}
              className={cn("sim-card rounded-lg border-l-2 p-4", s.border)}
            >
              <div className="flex items-start justify-between gap-3 mb-1.5">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="sim-mono text-[10px] font-bold text-[#9AA0AC]">#{i + 1}</span>
                  <span className={cn("sim-mono text-[9px] px-1.5 py-0.5 rounded border", s.chip)}>{s.label}</span>
                  <span className="sim-mono text-[10px] text-[#C2C5CE]">{o.agent_name || meta.short}</span>
                </div>
                {o.estimated_cvr_lift && (
                  <span className="sim-mono text-xs font-bold text-[#10B981] flex items-center gap-1 shrink-0">
                    <TrendingUp className="w-3 h-3" />{o.estimated_cvr_lift}
                  </span>
                )}
              </div>
              <p className="text-[#F5F5F5] text-sm font-medium leading-snug">{o.issue}</p>
              {o.element && <p className="sim-mono text-[10px] text-[#9AA0AC] mt-1">{o.element}</p>}
              {o.fix && (
                <div className="flex items-start gap-2 mt-2.5 pt-2.5 border-t border-[#1c1c1f]">
                  <ArrowRight className="w-3.5 h-3.5 text-[#00F0FF] mt-0.5 shrink-0" />
                  <p className="text-[#D4D4D8] text-xs leading-relaxed">{o.fix}</p>
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
